<template>
  <PageHousing>
    <div
      class="tabs-wrapper startup-tab section-space--mt_30 section-space--pb_120"
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div
              class="section-title-wrapper text-center section-space--mb_60 wow move-up"
            >
              <h2 class="section-title font-weight--bold mb-15">Who we Are.</h2>
            </div>
          </div>
        </div>
        <AboutUsTabs />
      </div>
    </div>
  </PageHousing>
</template>

<script>
import AboutUsTabs from "../components/AboutUsTabs";
import PageHousing from "../components/PageHousing";

export default {
  components: {
    AboutUsTabs,
    PageHousing,
  },

  metaInfo: {
    title: "HobbsTech - About Us",
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
  },
};
</script>
